// extracted by mini-css-extract-plugin
module.exports = {"rating":"Rating_rating__j9yXo","rating__stars-row":"Rating_rating__stars-row__xDlML","rating__selected-star":"Rating_rating__selected-star__NVSfV"};